(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"));
	else if(typeof define === 'function' && define.amd)
		define(["base"], factory);
	else if(typeof exports === 'object')
		exports["module-common-abc"] = factory(require("base"));
	else
		root["module-common-abc"] = factory(root["base"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : main.js
	               *  Description:
	               *  Main File Module Sample
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'module-common-abc';

	    var base = __webpack_require__(3);
	    var autoGrow = __webpack_require__(4);
	    var fileSelector = __webpack_require__(5);
	    var onlyNumbers = __webpack_require__(6);
	    var uuid = __webpack_require__(7);
	    var downloadFile = __webpack_require__(8);
	    var tmxProfilerService = __webpack_require__(9);


	    //var constants = require('./constants');

	    var deps = [];

	    module.exports = base.createModule(module.name, deps).
	    constant(__webpack_require__(10)).
	    factory('uuid', [uuid]).
	    factory('downloadFile', [downloadFile]).
	    factory('tmxProfilerService', [tmxProfilerService]).
	    directive('autoGrow', ['$window', autoGrow]).
	    directive('fileSelector', ['uuid', '$timeout', fileSelector]).
	    directive('onlyNumbers', onlyNumbers);
	    //.service(require('abcCommonServices'));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Created by dmarthak on 29/03/18.
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.exports = function ($window) {
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                element.css('overflow', 'hidden');
	                element.on('input', function (e) {
	                    if (this.value.length > parseInt(attrs.maxlength)) {
	                        this.value = this.value.substr(0, parseInt(attrs.maxlength));
	                    }
	                });
	                var update = function update() {
	                    element.css("height", "auto");
	                    var height = element[0].scrollHeight;
	                    if (height > 0) {
	                        element.css("height", height + "px");
	                    }
	                };
	                scope.$watch(attrs.ngModel, function () {
	                    update();
	                });
	                attrs.$set("ngTrim", "false");
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Created by noghan odedra on 01/04/18.
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.exports = function (uuid, $timeout) {

	        function getTemplate(element, attrs) {
	            return '\n                  <div class="file-selector">\n\n\t                  <div class="field-row">\n\t\t                  <div class="upload-info">\n\t\t\t                  <label for="file" class="field-title" lp-i18n="{{chooseFileLabelText}}"></label>\n\t\t\t                  <div class="fileUpload btn">\n\t\t\t\t                  <input name="file" type="file" class="upload" />\n\t\t\t\t                  <span class="visible-xs" lp-i18n="abc.common.select.file"></span>\n\t\t\t\t                  <div class="hidden-xs">\n\t\t\t\t\t                  <span class="drop-file" lp-i18n="abc.common.drag.drop.file"></span>\n\t\t\t\t\t                  <span> </span>\n\t\t\t\t\t                  <span class="select-file" lp-i18n="abc.common.or.select.file"></span>\n\t\t\t\t                  </div>\n\t\t\t\t                  <p class="file-type">\n                            <span ng-if="uploadInstructionsText2" lp-i18n="{{uploadInstructionsText2}}" class="instruction-message"/>\n                            <span lp-i18n="{{uploadInstructionsText}}"/>\n                            <span ng-if="uploadError" class="file-error" lp-i18n="{{errorMessage}}"></span>\n                          </p>\n\t\t\t                  </div>\n\t\t                  </div>\n\t                  </div>\n\n\t                  <div class="row">\n\t                        <div  class="col-xs-12 sm-6 col-sm-12 uploaded-file-list-wrap">\n\t                          <div ng-show="files && files.length > 0" class="file-info uploaded-file-list-title">\n\t                            <div class="file-name-title" lp-i18n="abc.common.name"></div>\n\t                            <div class="file-name-size" lp-i18n="abc.common.size"></div>\n\t                            <div class="file-name-type" lp-i18n="abc.common.type"></div>\n\t                            <div class="file-delete-title">&nbsp;</div>\n\t                          </div>\n\t                          <div class="file-info clear-both" ng-class="item.isError ? \'file-info-error\' : \'file-info-success\' " ng-repeat="file in files">\n\t                            <div class="file-name" title="{{file.name}}">\n\t                              {{ file.name }}\n\t                            </div>\n\t                            <div class="file-size">\n\t                              {{ file.size/(1024*1024)|number:2 }} <span lp-i18n="abc.common.mb"></span>\n\t                            </div>\n\t                            <div class="file-size">\n\t                              {{getFileType(file)}}\n\t                            </div>\n\t                            <div class="file-delete-icon">\n\t\t                             <span ng-if="showDeleteButton === true || showDeleteButton === \'true\'">\n\t\t                                  <em class="fa-times-thin fa-3x" aria-hidden="true" ng-click="removeFile(file)"></em>\n\t\t                             </span>\n\t                            </div>\n\t                          </div>\n\t                        </div>\n\t                  </div>\n\t                </div>\n                  ';


















































	        }

	        return {
	            restrict: 'E',
	            replace: true,
	            scope: {
	                selectedFiles: '=',
	                allowedFileExtensions: '@', //set comma separated string as value of this field
	                chooseFileLabelText: '@',
	                uploadInstructionsText: '@',
	                uploadInstructionsText2: '@',
	                showDeleteButton: '@',
	                maxFiles: '@',
	                maxFileSizeMb: '@',
	                validationMessagesMap: '=',
	                onError: '&',
	                onFileAdded: '&',
	                onFileRemoved: '&',
	                onFileLoadingComplete: '&' },

	            template: getTemplate,
	            compile: function compile(tElement, tAttrs, transclude) {
	                var fileInput = angular.element(tElement[0].querySelector("input[type='file']"));
	                if (!tAttrs.maxFiles) {
	                    tAttrs.maxFiles = 1;
	                    fileInput.removeAttr("multiple");
	                } else {
	                    fileInput.attr("multiple", "multiple");
	                }

	                if (!tAttrs.maxFileSizeMb) {
	                    tAttrs.maxFileSizeMb = 1;
	                }

	                var fileId = uuid.new();
	                fileInput.attr("id", fileId);

	                return function (scope, el, attrs, ctl) {
	                    var TOO_MANY_FILES = "TOO_MANY_FILES";
	                    var INVALID_EXTENSION = "INVALID_EXTENSION";
	                    var MAX_SIZE_EXCEEDED = "MAX_SIZE_EXCEEDED";
	                    var ALREADY_EXISTS = "ALREADY_EXISTS";

	                    var DEFAULT_VALIDATION_MESSAGES_MAP = {
	                        TOO_MANY_FILES: "Can not upload more then allowed files limit which is " + scope.maxFiles,
	                        INVALID_EXTENSION: "Files are uploaded with extensions which are not allowed. Valid extensions are: " + scope.allowedFileExtensions,
	                        MAX_SIZE_EXCEEDED: "Files are larger than the specified max size (" + scope.maxFileSizeMb + " MB)",
	                        ALREADY_EXISTS: "File(s) already uploaded." };

	                    Object.freeze(DEFAULT_VALIDATION_MESSAGES_MAP);
	                    var defaultAllowedExtensions = ['pdf', 'txt'];

	                    var validationMessagesMap = scope.validationMessagesMap != undefined && scope.validationMessagesMap != '' ? scope.validationMessagesMap : DEFAULT_VALIDATION_MESSAGES_MAP;
	                    scope.uploadError = false;
	                    scope.errorMessage = "";

	                    scope.$watch('selectedFiles', function (selectedFiles) {
	                        scope.files = selectedFiles;
	                        $timeout(function () {
	                            scope.uploadError = false;
	                        }, 100);
	                        if (selectedFiles && selectedFiles.length > 0)
	                        resetFileInput();
	                    });

	                    var validFileExtensions = scope.allowedFileExtensions ? scope.allowedFileExtensions.split(',') : defaultAllowedExtensions;
	                    if (validFileExtensions) {
	                        var arrayLength = validFileExtensions.length;
	                        for (var i = 0; i < arrayLength; i++) {
	                            validFileExtensions[i] = validFileExtensions[i].toLowerCase();
	                        }
	                    }

	                    scope.getFileExtension = function (file) {
	                        var extension = file.name.substr(file.name.lastIndexOf('.') + 1);
	                        return extension.toLowerCase();
	                    };

	                    scope.getFileType = function (file) {
	                        var extension = scope.getFileExtension(file);
	                        return extension.toUpperCase();
	                    };

	                    scope.getCustomFileData = function (file) {
	                        var fileDetails = {};
	                        fileDetails.mimeType = file.type;
	                        fileDetails.fileExtension = scope.getFileExtension(file);
	                        fileDetails.fileName = file.name;
	                        return fileDetails;
	                    };

	                    function findFile(fileName, files) {
	                        for (var _i = files.length - 1; _i >= 0; --_i) {
	                            if (files[_i].name == fileName) {
	                                return { 'index': _i, 'file': files[_i] };
	                            }
	                        }
	                        return undefined;
	                    }

	                    function resetEventTarget(event) {
	                        event.target.value = "";
	                        //event.srcElement.value = ""; //hack to allow uploading same file again
	                    }

	                    scope.removeFile = function (file) {
	                        var fileItem = findFile(file.name, scope.files);
	                        if (fileItem) {
	                            scope.files.splice(fileItem.index, 1);
	                            if (scope.onFileRemoved) {
	                                scope.onFileRemoved({ file: fileItem.file });
	                            }
	                        }
	                        if (scope.files && scope.files.length === 0) {
	                            scope.uploadError = false;
	                            scope.errorMessage = "";
	                            resetFileInput();
	                        }
	                    };

	                    el.bind('change', function (e) {
	                        scope.uploadError = false;
	                        scope.errorMessage = "";

	                        if (!e.target.files.length) {
	                            resetEventTarget(e);
	                            return;
	                        }

	                        var tooBig = [];
	                        var invalidExt = [];
	                        var fileExists = [];

	                        if (scope.files.length + e.target.files.length > scope.maxFiles) {
	                            raiseError(e.target.files, TOO_MANY_FILES, "Cannot upload " + scope.files.length + " files, maximum allowed is " + scope.maxFiles, e);
	                            scope.uploadError = true;
	                            scope.errorMessage = validationMessagesMap[TOO_MANY_FILES];
	                            scope.$apply(function () {});
	                            return;
	                        }var _loop = function _loop(

	                        _i2) {
	                            if (_i2 >= e.target.files.length) return 'break';

	                            var file = e.target.files[_i2];
	                            var ext = scope.getFileExtension(file);
	                            var fileItem = findFile(file.name, scope.files);
	                            if (file.size > scope.maxFileSizeMb * 1048576) {
	                                tooBig.push(file);
	                            } else if (validFileExtensions && validFileExtensions.indexOf(ext) == -1) {
	                                invalidExt.push(file);
	                            } else
	                            if (fileItem && fileItem.file) {
	                                fileExists.push(file);
	                            } else
	                            {
	                                if (file) {
	                                    scope.files.push(file);
	                                    if (scope.onFileAdded) {
	                                        scope.onFileAdded({ file: file });
	                                    }
	                                    var reader = new FileReader();
	                                    reader.readAsDataURL(file);
	                                    reader.onload = function (e) {
	                                        // browser completed reading file - display it
	                                        var fileDetails = scope.getCustomFileData(file);
	                                        var base64result = e.target.result.split(',')[1];
	                                        fileDetails.fileData = base64result;
	                                        if (scope.onFileLoadingComplete) {
	                                            scope.onFileLoadingComplete({ fileDetails: fileDetails });
	                                        }
	                                    };
	                                }
	                            }};for (var _i2 = 0; _i2 < scope.maxFiles; _i2++) {var _ret = _loop(_i2);if (_ret === 'break') break;
	                        }

	                        if (invalidExt.length > 0) {
	                            raiseError(invalidExt, INVALID_EXTENSION, "Files are upload with extensions which are not allowed. Valid extensions are: " + scope.allowedFileExtensions, e);
	                            scope.uploadError = true;
	                            scope.errorMessage = validationMessagesMap[INVALID_EXTENSION];
	                            scope.$apply(function () {});
	                            return;
	                        }
	                        if (tooBig.length > 0) {
	                            raiseError(tooBig, MAX_SIZE_EXCEEDED, "Files are larger than the specified max (" + scope.maxFileSizeMb + "MB)", e);
	                            scope.uploadError = true;
	                            scope.errorMessage = validationMessagesMap[MAX_SIZE_EXCEEDED];
	                            scope.$apply(function () {});
	                            return;
	                        }
	                        if (fileExists.length > 0) {
	                            raiseError(fileExists, ALREADY_EXISTS, "File(s) already uploaded.", e);
	                            scope.uploadError = true;
	                            scope.errorMessage = validationMessagesMap[ALREADY_EXISTS];
	                            scope.$apply(function () {});
	                            return;
	                        }
	                        resetEventTarget(e);
	                        scope.$apply(function () {});
	                    });

	                    function raiseError(files, type, msg, event) {
	                        if (scope.onError) {
	                            scope.onError({ files: files, type: type, msg: msg });
	                        }
	                        resetEventTarget(event);
	                        //resetFileInput();
	                    }

	                    function resetFileInput() {

	                        fileInput.remove();
	                        var input = document.createElement("input");
	                        var attr = document.createAttribute("type");
	                        attr.nodeValue = "file";
	                        input.setAttributeNode(attr);

	                        var inputId = uuid.new();
	                        attr = document.createAttribute("id");
	                        attr.nodeValue = inputId;
	                        input.setAttributeNode(attr);

	                        attr = document.createAttribute("style");
	                        attr.nodeValue = "opacity: 0;display:inline;width:0";
	                        input.setAttributeNode(attr);

	                        attr = document.createAttribute("class");
	                        attr.nodeValue = "upload";
	                        input.setAttributeNode(attr);

	                        if (scope.maxFiles > 1) {
	                            attr = document.createAttribute("multiple");
	                            attr.nodeValue = "multiple";
	                            input.setAttributeNode(attr);
	                        }

	                        fileInput = angular.element(input);
	                        if (fileInput) {
	                            fileInput.value = '';
	                        }
	                    }
	                };
	            } };


	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Created by dmarthak on 26/04/18.
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.exports = function () {
	        return {
	            restrict: 'A',
	            require: 'ngModel',
	            link: function link(scope, element, attr, ngModelCtrl) {
	                function transformInput(text) {
	                    var transformedInput = text.replace(/[^0-9]/g, '');
	                    if (transformedInput !== text) {
	                        ngModelCtrl.$setViewValue(transformedInput);
	                        ngModelCtrl.$render();
	                    }
	                    return transformedInput;
	                }
	                ngModelCtrl.$parsers.push(transformInput);
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict"; /**
	               * Created by dmarthak on 29/03/18.
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';

		module.exports = function () {

			var svc = {
				new: function _new() {
					function _p8(s) {
						var p = (Math.random().toString(16) + "000000000").substr(2, 8);
						return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
					}
					return _p8() + _p8(true) + _p8(true) + _p8();
				},

				empty: function empty() {
					return '00000000-0000-0000-0000-000000000000';
				} };

			return svc;

		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';

		module.exports = function () {


			var dataURIToBlob = function dataURIToBlob(dataURI, mimeType) {

				var binStr = atob(dataURI.split(',')[1]),
				len = binStr.length,
				arr = new Uint8Array(len),
				mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

				for (var i = 0; i < len; i++) {
					arr[i] = binStr.charCodeAt(i);
				}

				if (window.navigator.userAgent.indexOf("Safari") > -1) {
					mimeString = mimeType;
				}

				return new Blob([arr], {
					type: mimeString });


			};

			var downloadBlob = function downloadBlob(response, fileName, mimeType) {

				var linkElement = document.createElement('a');
				var dataURI = "data:application/octet-stream;base64," + response;
				var blob = dataURIToBlob(dataURI, mimeType);
				var url = URL.createObjectURL(blob);
				linkElement.download = fileName;
				linkElement.href = url;
				linkElement.onclick = function () {
					requestAnimationFrame(function () {
						URL.revokeObjectURL(url);
					});
				};

				var clickEvent = new MouseEvent("click", {
					"view": window,
					"bubbles": true,
					"cancelable": false });

				linkElement.dispatchEvent(clickEvent);
			};

			var downloadFile = {

				pdfForMobile: function pdfForMobile(response) {
					var jsonObject = {
						"fileInfo": {
							"fileName": response.fileName,
							"fileExtension": response.fileExtension,
							"fileData": response.fileData } };


					gadgets.pubsub.publish(lpConstants.PUBLISH.FILE_INFO, { 'relationship': 'Child', 'target': 'PdfView', "payload": jsonObject });
				},

				pdf: function pdf(response) {
					var linkElement = document.createElement('a');
					var content = 'data:' + response.mimeType + ';base64,' + response.fileData;
					linkElement.setAttribute('href', content);
					linkElement.setAttribute('download', response.fileName);
					// IE workaround
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						var byteCharacters = atob(response.fileData);
						var byteNumbers = [];
						for (var i = 0; i < byteCharacters.length; i++) {
							byteNumbers.push(byteCharacters.charCodeAt(i));
						}
						var byteArray = new Uint8Array(byteNumbers);
						var blob = new Blob([byteArray], { type: response.mimeType });
						window.navigator.msSaveOrOpenBlob(blob, response.fileName);
					} else
					{
						downloadBlob(response.fileData, response.fileName, response.mimeType);
					}
				} };

			return downloadFile;

		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // function getCookie(cname) {
	    //     let name = cname + "=";
	    //     let decodedCookie = decodeURIComponent(document.cookie);
	    //     let ca = decodedCookie.split(';');
	    //     for(let i = 0; i <ca.length; i++) {
	    //         let c = ca[i];
	    //         while (c.charAt(0) == ' ') {
	    //             c = c.substring(1);
	    //         }
	    //         if (c.indexOf(name) == 0) {
	    //             return c.substring(name.length, c.length);
	    //         }
	    //     }
	    //     return "";
	    // }

	    var UnitCodeAndNumberMap = {
	        'ALG': '08',
	        'BAH': '01',
	        'EGY': '09',
	        'FRA': '05',
	        'JOR': '02',
	        'LON': '03',
	        'MIL': '07',
	        'NYK': '04',
	        'PAR': '06',
	        'SAG': '10',
	        'TNE': '11',
	        'TNN': '12' };


	    function getUnitNumber() {
	        var countryCode = localStorage.getItem('countryCode');
	        if (!countryCode) {
	            return '00';
	        }
	        var unitNumber = UnitCodeAndNumberMap[countryCode];
	        console.log(UnitCodeAndNumberMap, countryCode, unitNumber);
	        return unitNumber;
	    }

	    function getGeneratedSessionId(pageId) {
	        var unitNumber = getUnitNumber();
	        var webSessionId = sessionStorage.getItem('userSessionId');
	        var tmxSessionId = webSessionId + unitNumber + pageId;
	        return tmxSessionId;
	    }

	    function getGeneratedPaymentSessionId(pageId, PaymentDetail) {
	        var unitNumber = getUnitNumber();
	        var webSessionId = sessionStorage.getItem('userSessionId');
	        var PaymentDetailFix = PaymentDetail.replaceAll(/[^a-z0-9_-]/gi, 'M');
	        var tmxSessionId = webSessionId + PaymentDetailFix + unitNumber + pageId;
	        return tmxSessionId;
	    }

	    function getGeneratedPreLoginSessionId(pageId, loginUsername, loginPassword) {
	        var unitNumber = '00';
	        var partOne = "a20e4a88-c1b2-4dca";
	        var partTwo = "850c-40d3643b74c8";

	        var decodedUsername1 = loginUsername.replaceAll(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_|]/g, '_');
	        var decodedPassword1 = loginPassword.replaceAll(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_|]/g, '_');
	        var decodedUsername2 = decodedUsername1.replaceAll(' ', '_');
	        var decodedPassword2 = decodedPassword1.replaceAll(' ', '_');
	        var decodedUsername = decodedUsername2.replaceAll(/[^a-z0-9_]/gi, 'A');
	        var decodedPassword = decodedPassword2.replaceAll(/[^a-z0-9_]/gi, 'A');
	        // const today = new Date();
	        // const todayFormatted = today.toLocaleDateString('en-GB').split('/').reverse().join('');

	        var tmxSessionId = decodedPassword + partOne + decodedUsername + partTwo + unitNumber + pageId;
	        return tmxSessionId;
	    }

	    function getGeneratedLoginSuccessSessionId(pageId) {
	        var unitNumber = '00';
	        var webSessionId = sessionStorage.getItem('userSessionId');
	        var tmxSessionId = webSessionId + unitNumber + pageId;
	        return tmxSessionId;
	    }

	    function getGeneratedLoginOTPSessionId(pageId, otp) {
	        var unitNumber = '00';
	        var webSessionId = sessionStorage.getItem('userSessionId');
	        var tmxSessionId = webSessionId + otp + unitNumber + pageId;
	        return tmxSessionId;
	    }

	    //@ngInject -- test "ban3nmwg" -- production "2rb7fpwe"
	    module.exports = function ($cookies) {
	        var tmxProfilerServices = {
	            sendLoginTmxProfiler: function sendLoginTmxProfiler(loginUsername, loginPassword) {
	                var pageId = "3100";
	                var tmxSessionId = getGeneratedPreLoginSessionId(pageId, loginUsername, loginPassword);
	                console.log(tmxSessionId);
	                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
	            },
	            sendLoginSuccessTmxProfiler: function sendLoginSuccessTmxProfiler() {
	                var pageId = "3100";
	                var tmxSessionId = getGeneratedLoginSuccessSessionId(pageId);
	                console.log(tmxSessionId);
	                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
	            },
	            sendLoginOTPTmxProfiler: function sendLoginOTPTmxProfiler(otp) {
	                var pageId = "3100";
	                var tmxSessionId = getGeneratedLoginOTPSessionId(pageId, otp);
	                console.log(tmxSessionId);
	                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
	            },
	            sendTmxProfiler: function sendTmxProfiler(pageId) {
	                var tmxSessionId = getGeneratedSessionId(pageId);
	                console.log(tmxSessionId);
	                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
	            },
	            sendPaymentTmxProfiler: function sendPaymentTmxProfiler(pageId, PaymentDetail) {
	                var tmxSessionId = getGeneratedPaymentSessionId(pageId, PaymentDetail);
	                console.log(tmxSessionId);
	                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
	            } };

	        return tmxProfilerServices;

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict"; /**
	               * Created by dhavaljoshi on 05/02/18.
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  var REGEX = {
	    "PASSWORD": /^(?=.*\d.*\d.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9\x20])(?=\S+$).{12,}$/,
	    "DEVICE_REGEX": /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i,
	    "IGNORE_SPACE_REGEX": /\s*,\s*/ };


	  var PUBLISH = {
	    "JSON_SEND": "mobile.jsonData.sendData",
	    "LOGIN_SUCCESS": "login-loaded-successfully",
	    "CXP_ITEM_LOADED": "cxp.item.loaded",
	    "BB_ITEM_LOADED": "bb.item.loaded",
	    "CLEAR_TOKEN": "mobile.clear.token",
	    "LOAD_SUB_PAGE": "mobile.loadSubPage",
	    "SIGNOUT": "mobile.signout",
	    "PIN_READY": "mobile.login.with.pin.ready",
	    "SHOW_PROGRESS": "mobile.show.progress",
	    "JSON_UPDATE": "mobile.json.update.data",
	    "FILE_INFO": "mobile.fileInformation",
	    "LOAD_FROM_STACK": "mobile.loadFromStack",
	    "HIDE_PROGRESS": "mobile.hide.progress",
	    "TOOLBAR_ENABLE": "mobile.toolbar.enable",
	    "TOOLBAR_DISABLE": "mobile.toolbar.disable",
	    "REQUEST_PREPARE_TRANSFER": "launchpad-retail.requestPrepareTransfer",
	    "TRANSFER_ACTION_RESPONSE": "transfer-action-response",
	    "SHOW_MASTER_PROGRESS": "mobile.show.master.progress",
	    "HIDE_MASTER_PROGRESS": "mobile.hide.master.progress" };


	  var SUBSCRIBE = {
	    "JSON_DATA": "mobile.json.data",
	    "LOGIN_WITH_PIN": "mobile.login.with.pin",
	    "SIGNOUT": "mobile.signout.publish",
	    "TRANSFER_DETAIL_ID": "transfer-detail-id" };


	  var COMMON = {
	    "CHANGE_PASSWORD": "CHANGE_PASSWORD",
	    "ACTIVE": "ACTIVE",
	    "XBBXSRF": "X-BBXSRF",
	    "X_BBSC": "X_BBSC",
	    "XBBXSRFTOKEN": "X-BBXSRFTOKEN",
	    "USER_SESSIONID": "userSessionId",
	    "LOGIN_WITH_MFA": "LOGIN_WITH_MFA",
	    "LOGIN_FIRST_TIME": "LOGIN_FIRST_TIME",
	    "TOKEN": "token",
	    "COUNTRY": "countryPreferences",
	    "PORTAL": "portalName",
	    "ACCESS": "accessRights",
	    "TEMPLATE": "template",
	    "STATUS": "status",
	    "FIRST_TIME_USER": "firstTimeUsser",
	    "INVALID_PASSWORD": "INVALID_PASSWORD",
	    "INVALID_OLD_PASSWORD": "INVALID_OLD_PASSWORD",
	    "COOKIE_BBXSRF": "BBXSRF",
	    "FORGOT_PASSWORD": "FORGET_PASSWORD",
	    "SET_PASSWORD": "SET_PASSWORD",
	    "REGISTRATION": "REGISTRATION",
	    "DEVICE_NOT_BOUND": "DEVICE_NOT_BOUND",
	    "APPROVED": "APPROVED",
	    "REJECTED": "REJECTED",
	    "EFAWATEERCOM": "EFAWATEERCOM",
	    "CREDITCARD": "CREDITCARD",
	    "PREPAID": "Prepaid",
	    "LOCKED_USER": "LOCKED_USER",
	    "CLIENT_NAME": "CLIENT_NAME" };


	  var PAGE = {
	    "MY_BANKING": "MyBanking",
	    "TERMS_AND_CONDITIONS": "terms-and-conditions",
	    "CHANGE_PASSWORD": "change-password",
	    "SIGN_IN": "sign-in",
	    "VERIFICATION_CODE": "verificationCode",
	    "NEW_PASSWORD": "newPassword",
	    "FORGOT_PASSWORD": "forgotPassword",
	    "VERIFICATION_METHODS": "mobile.verification",
	    "PIN": "mobile.pin",
	    "MANAGE_PASSWORD": "mobile.manage.password",
	    "PIN_CHANGE": "mobile.pin.change",
	    "USER_VERIFICATION": "mobile.user.verification",
	    "SAVED_TRANSFER": "mobile.saved.transfer",
	    "CONFIRM_PAYMENT": "mobile.confirmPayment",
	    "CONFIRM_TRANSFER": "mobile.confirmTransfer" };


	  var CUSTOM_ERROR_CODES = {
	    "UNAUTHORISED": 401,
	    "ALREADY_EXISTS": 409,
	    "BOUND_ERROR": 451,
	    "SERVER_ERROR": 500 };


	  var TAGS = {
	    "CC_PAYMENT": "mobile.creditcardpayment",
	    "SIGN_IN": "sign-in" };


	  var MOBILE_SDK_BUTTONS = {
	    "POSITIVE": "POSITIVE",
	    "NEGATIVE": "NEGATIVE",
	    "NEUTRAL": "NEUTRAL" };



	  Object.freeze(REGEX);
	  Object.freeze(PUBLISH);
	  Object.freeze(SUBSCRIBE);
	  Object.freeze(COMMON);
	  Object.freeze(PAGE);
	  Object.freeze(CUSTOM_ERROR_CODES);
	  Object.freeze(TAGS);
	  Object.freeze(MOBILE_SDK_BUTTONS);

	  exports.lpConstants = {
	    "REGEX": REGEX,
	    "PUBLISH": PUBLISH,
	    "SUBSCRIBE": SUBSCRIBE,
	    "COMMON": COMMON,
	    "PAGE": PAGE,
	    "CUSTOM_ERROR_CODES": CUSTOM_ERROR_CODES,
	    "TAGS": TAGS,
	    "MOBILE_SDK_BUTTONS": MOBILE_SDK_BUTTONS };


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js